import React from 'react';

const MicInput = () => {
    return (
      <React.Fragment>
        <div className="btn__base r1c17">
          <div className="btn">
            <div className="pin">
              <div className="pin-line"></div>
              <div className="pin-top"></div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  };

export default MicInput;